import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Loader } from './Loader';
import * as actions from "../redux/user";

class StartSession extends Component {
    componentDidMount() {
        this.props.startSession(this.props.history);
    }

    render() {
        return <Loader loading={true} />;
    }
}

const mapStateToProps = ({ user }) => ({
    name: user.name
});

export default connect(mapStateToProps, actions)(StartSession);


// WEBPACK FOOTER //
// ./src/components/StartSession.js